import React, { useState } from 'react'
import logo from "../../../../assets/ReEngageFollowup/img/logo-status.png";
import ModalHeaderTop from './ModalHeaderTop';
import { useClaimReg } from "../../../../Hooks/useClaimReg";

const HeaderTop = ({ userDetails }) => {
    const [showModal, setShowModal] = useState(false);
    const { clickReEngage } = useClaimReg();
    const source = localStorage.getItem("flp_source");
    const re_engaged_id = localStorage.getItem("re_engagedId");
    const product  = localStorage.getItem("product_type");
    const getCurrentDate = () => {
        const date = new Date();
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'long' });
        return `${day}-${month}`;
    };

    const handleOpenModal = async (e) => {
        e.preventDefault();
        const page_name = product === "Credit Card" ? "intro_cc_flp" : "intro_hp_flp";
        await clickReEngage(
            userDetails.uuid,
            re_engaged_id,
            page_name,
            "status_update_popup",
            e.target.value,
            source
        );
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>

            <div className="container">
                <ModalHeaderTop showModal={showModal} onClose={handleCloseModal} userDetails={userDetails} />
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6 mt-1">
                        <a className="status-card mx-auto" onClick={handleOpenModal}>
                            <div className="status-body">
                                <div className="status-left">
                                    <div className="status-icon">
                                        <img src={logo} alt="icon" />
                                    </div>
                                    <div className="status-text">
                                        <div className="title">Status Update</div>
                                        <div className="subtitle">{userDetails.user_lender} Overdraft Current Account</div>
                                    </div>
                                </div>
                                <div className="status-date">{getCurrentDate()}</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </>
    )
}

export default HeaderTop